/**
 * Action types for node status functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of node status.
 */

// Get node status constants
export const NODE_STATUS_REQUEST_GET = 'NODE_STATUS_REQUEST_GET';
export const NODE_STATUS_RESPONSE_GET_SUCCESS = 'NODE_STATUS_RESPONSE_GET_SUCCESS';
export const NODE_STATUS_RESPONSE_GET_FAIL = 'NODE_STATUS_RESPONSE_GET_FAIL'
